import * as classnames from 'classnames'
import {ILuminopiaLogoVerticalTheme, LuminopiaLogoVertical} from 'core/components/LuminopiaLogo'
import {routeProps} from 'core/utils/react-router-helpers'
import * as React from 'react'
import {RouteComponentProps} from 'react-router'
import * as classNames from './Register.css'

interface ITheme extends ILuminopiaLogoVerticalTheme {
  logoContainer?: string
  formContainer?: string
}
interface IProps extends RouteComponentProps<any> {
  /** return value is rendered in the form container */
  renderForm?: (routeProps: RouteComponentProps<any>) => any
  className?: string
  theme?: ITheme
}

/**
 * Standard interface with a Luminopia logo as the header.
 */
class Register extends React.Component<IProps, {}> {
  public render() {
    const { renderForm, theme = {} } = this.props

    const logoTheme = {
      graphic: classnames(theme.graphic, classNames.graphic),
      lettering: classnames(theme.lettering, classNames.lettering),
    }

    return (
      <div className={this.props.className}>
        <div className={theme.logoContainer}>
          <LuminopiaLogoVertical theme={logoTheme} />
        </div>
        <div className={theme.formContainer}>
          {renderForm && renderForm(routeProps(this.props))}
        </div>
      </div>
    )
  }
}

export default Register



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/register/Register.tsx